import { getRequest } from "../../../services/RestServices";
import * as urls from "../../api/C4S Decommission - Replacement/url";

export const getFilterValues = async (providerOrder) => {
  try {
    return await getRequest(`${urls.CRITERIA_FOR_RETURNABLE_ITEM}/${providerOrder}`);
  } catch (err) {
    return err;
  }
};

export const getReturnableItemDetails = async (queryParam) => {
  try {
    return await getRequest(`${urls.RETURNABLE_ITEM_DETAILS}?${queryParam}`);
  } catch (err) {
    return err;
  }
};
